<script setup lang="ts">
import { getColor, getLightnessScale } from "@/dokos-ui/composables/colors";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    theme?: string;
    variant?: string;
    size?: string;
  }>(),
  {
    size: "md",
    theme: "gray",
    variant: "soft",
  },
);

const scale = computed(() => getLightnessScale(props.variant, props.theme));
const bgColor = computed(() => getColor(props.theme, scale.value.bg.base));
const fgColor = computed(() => getColor(props.theme, scale.value.text.base));

const SIZES = {
  sm: "text-sm px-1.5 py-0.5",
  md: "text-sm px-2 py-0.5 leading-relaxed",
  lg: "text-md px-3 py-1 leading-relaxed",
};
</script>

<template>
  <span
    class="BBadge rounded-full"
    :class="SIZES[size]"
    :style="{ background: bgColor, color: fgColor }"
  >
    <slot></slot>
  </span>
</template>

<style>
.BBadge {
  box-shadow: inset 0px 0px 0.5em -0.4em currentColor;
}
</style>